export default {
  init() {
    // JavaScript to be fired on the page

    /* eslint-disable */

	/* eslint-enable */

  },
  finalize() {
    // JavaScript to be fired on the page, after the init JS
		
	/* eslint-disable */


  //--------------------  CONVEYNCING FORM START ------------------------------

    $('#ccItem1').html($('#ccContent1').html());
    $('#ccItem2').html($('#ccContent2').html());
    $('#ccItem3').html($('#ccContent3').html());

    if (jQuery(".MConveyncingForm.mobile-form").is(":visible"))
    {
        jQuery('#calculateconveyanceModal').modal('show');
    }

    //--------------------PLUS MINUS FIELD START -------------------------------

    $('.btn-number').click(function (e) {
        e.preventDefault();
        var fieldName = $(this).attr('data-field');
        var type = $(this).attr('data-type');
        var input = $("input[name='" + fieldName + "']");
        var currentVal = parseInt(input.val());
        if (!isNaN(currentVal)) {
            if (type == 'minus') {

                if (currentVal > input.attr('min')) {
                    input.val(currentVal - 1).change();
                }
                if (parseInt(input.val()) == input.attr('min')) {
                    $(this).attr('disabled', true);
                }

            } else if (type == 'plus') {

                if (currentVal < input.attr('max')) {
                    input.val(currentVal + 1).change();
                }
                if (parseInt(input.val()) == input.attr('max')) {
                    $(this).attr('disabled', true);
                }

            }
        } else {
            input.val(0);
        }
    });
    $('.input-number').focusin(function () {
        $(this).data('oldValue', $(this).val());
    });
    $('.input-number').change(function () {

        var minValue = parseInt($(this).attr('min'));
        var maxValue = parseInt($(this).attr('max'));
        var valueCurrent = parseInt($(this).val());
        var name = $(this).attr('name');
        if (valueCurrent >= minValue) {
            $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
        } else {
            alert('Sorry, the minimum value was reached');
            $(this).val($(this).data('oldValue'));
        }
        if (valueCurrent <= maxValue) {
            $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
        } else {
            alert('Sorry, the maximum value was reached');
            $(this).val($(this).data('oldValue'));
        }
    });
    $(".input-number").keydown(function (e) {
// Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
                // Allow: Ctrl+A
                        (e.keyCode == 65 && e.ctrlKey === true) ||
                        // Allow: home, end, left, right
                                (e.keyCode >= 35 && e.keyCode <= 39)) {
                    // let it happen, don't do anything
                    return;
                }
                // Ensure that it is a number and stop the keypress
                if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                    e.preventDefault();
                }
            });
    //--------------------PLUS MINUS FIELD END -------------------------------------


    //--------------------  DCONVEYNCINGFORM RADIO START ---------------------------
    $('input[type=radio][name=typeofmatter]').change(function () {
        $('.typeofpurchasemortgage').prop("checked", false);
        $('.typeofpurchasebuytolet').prop("checked", false);
        $('.typeofpurchasefirsttimebuyer').prop("checked", false);
        $('.typeofpurchasehelptobuyISA').prop("checked", false);
        $('.typeofpurchaseSharedOwnership').prop("checked", false);
        $('.typeofpurchaseHelpToBuyEquityLoan').prop("checked", false);
        $('.typeofpurchaseNewBuild').prop("checked", false);
        $('.typeofsaleSharedOwnership').prop("checked", false);
        $('.typeofsalemortgage').prop("checked", false);
        $('.purchaseprice').removeAttr("required");
        $('.purchasepostcode').removeAttr("required");
        $('.saleprice').removeAttr("required");
        $('.salepostcode').removeAttr("required");
        $('.typeofleasepurchase').removeAttr("required");
        $('.typeofleasesale').removeAttr("required");
        $('.typeofpurchasemortgagelabel').removeClass('active');
        $('.typeofpurchasebuytoletlabel').removeClass('active');
        $('.typeofpurchasefirsttimebuyerlabel').removeClass('active');
        $('.typeofpurchasehelptobuyISAlabel').removeClass('active');
        $('.typeofpurchaseSharedOwnershiplabel').removeClass('active');
        $('.typeofpurchaseHelpToBuyEquityLoanLabel').removeClass('active');
        $('.typeofpurchaseNewBuildLabel').removeClass('active');
        $('.typeofsaleSharedOwnershiplabel').removeClass('active');
        $('.typeofsalemortgagelabel').removeClass('active');
        $('.purchasepricelabel').html('Purchase Price');
        $('.purchaseprice').prop('placeholder', 'Purchase Price');
        $('.purchasepostcodelabel').html('Purchase Postcode');
        $('.purchasepostcode').prop('placeholder', 'Purchase Postcode');
        $('.noBuyers').html('Number of Buyers');
        $('.typeofleasepurchaseLabel').html('Purchase property type');
        $('.typeofpurchaseTitle').html('Type of purchase');

        $('.typeofpurchasemortgagelabel').show();
        $('.typeofpurchasebuytoletlabel').show();
        $('.typeofpurchasefirsttimebuyerlabel').show();
        $('.typeofpurchasehelptobuyISAlabel').show();
        $('.typeofpurchaseSharedOwnershiplabel').show();
        $('.typeofpurchaseHelpToBuyEquityLoanLabel').show();
        $('.typeofpurchaseNewBuildLabel').show();

        $('.typeofpurchaseTitle').show();
        $('.typeofpurchasebtngroup').show();
        $('.typeofsaleTitle').hide();
        $('.typeofsalebtngroup').hide();

        if (this.value == 1) {
            $('.typeofpurchaseTitle').show();
            $('.typeofpurchasebtngroup').show();
            $('.typeofsaleTitle').hide();
            $('.typeofsalebtngroup').hide();
            $('.salePriceInfo').hide();
            $('.purchasePriceInfo').show();
            $('.typeofleasepurchase').show();
            $('.typeofleasesale').hide();
            $('.purchaseprice').attr('required', 'required');
            $('.purchasepostcode').attr('required', 'required');
            $('.typeofleasepurchase').attr('required', 'required');
        } else if (this.value == 2) {
            $('.typeofpurchaseTitle').hide();
            $('.typeofpurchasebtngroup').hide();
            $('.typeofsaleTitle').show();
            $('.typeofsalebtngroup').show();
            $('.salePriceInfo').show();
            $('.purchasePriceInfo').hide();
            $('.noBuyers').html("Number of Sellers");
            $('.typeofleasepurchase').hide();
            $('.typeofleasesale').show();
            $('.saleprice').attr('required', 'required');
            $('.salepostcode').attr('required', 'required');
            $('.typeofleasesale').attr('required', 'required');
            $('.typeofpurchaseTitle').hide();
            $('.typeofpurchasebtngroup').hide();
            $('.typeofsaleTitle').show();
            $('.typeofsalebtngroup').show();
        } else if (this.value == 3) {
            $('.typeofpurchaseTitle').show();
            $('.typeofpurchasebtngroup').show();
            $('.typeofsaleTitle').show();
            $('.typeofsalebtngroup').show();
            $('.salePriceInfo').show();
            $('.purchasePriceInfo').show();
            $('.typeofleasepurchase').show();
            $('.typeofleasesale').show();
            $('.purchaseprice').attr('required', 'required');
            $('.purchasepostcode').attr('required', 'required');
            $('.typeofleasepurchase').attr('required', 'required');
            $('.saleprice').attr('required', 'required');
            $('.salepostcode').attr('required', 'required');
            $('.typeofleasesale').attr('required', 'required');
            $('.typeofsaleTitle').show();
            $('.typeofsalebtngroup').show();
        } else if (this.value == 4) {
            $('.typeofpurchaseTitle').show();
            $('.typeofpurchaseTitle').html('Type of remortgage');
            $('.typeofpurchasemortgagelabel').hide();
            $('.typeofpurchasebuytoletlabel').show();
            $('.typeofpurchasefirsttimebuyerlabel').hide();
            $('.typeofpurchasehelptobuyISAlabel').hide();
            $('.typeofpurchaseSharedOwnershiplabel').hide();
            $('.typeofpurchaseHelpToBuyEquityLoanLabel').hide();
            $('.typeofpurchaseNewBuildLabel').hide();
            $('.salePriceInfo').hide();
            $('.purchasePriceInfo').show();
            $('.purchasepricelabel').html('Price');
            $('.purchaseprice').prop('placeholder', 'Price');
            $('.purchasepostcodelabel').html('Postcode');
            $('.purchasepostcode').prop('placeholder', 'Postcode');
            $('.typeofleasepurchase').show();
            $('.typeofleasesale').hide();
            $('.typeofleasepurchaseLabel').html("Property type");
            $('.purchaseprice').attr('required', 'required');
            $('.purchasepostcode').attr('required', 'required');
            $('.typeofleasepurchase').attr('required', 'required');
        }
    });
    //-------------------- DCONVEYNCINGFORM RADIO END ------------------------------

    $('#DConveyncingFormForm, #MConveyncingFormForm').on('submit', function ()
    {
        $('.ccGetQuote button').html('Processing...');
        $('.ccGetQuote button').prop('disabled', true);
    });



    $('#MConveyncingCarousel').on('slid.bs.carousel', function (e) {
        var active = $(e.target).find('.carousel-inner > .item.active');
        var currentSlide = active.index();
        $('#ccContinue').data('currentslide', currentSlide);
        if (currentSlide == 0) {
            $('#changeDetails').css('visibility', 'hidden');
        } else {
            $('#changeDetails').css('visibility', 'visible');
        }
        if (currentSlide == 2) {
            $('#ccContinue').css('visibility', 'hidden');
        } else {
            $('#ccContinue').css('visibility', 'visible');
        }
    });
    //-------------------- MCONVEYNCINGFORM FORM START ------------------------------

    $('#ccContinue').on('click', function (e) {

        var index = $('#ccContinue').data('currentslide');
        if (index == 0) {
            if (!checkInputError(jQuery('#MConveyncingFormForm .typeofmatterpurchase')))
                return;

            if (!checkInputError(jQuery('#MConveyncingFormForm .purchaseprice')))
                return;
            if (!checkInputError(jQuery('#MConveyncingFormForm .purchasepostcode')))
                return;

            if (!checkInputError(jQuery('#MConveyncingFormForm .saleprice')))
                return;
            if (!checkInputError(jQuery('#MConveyncingFormForm .salepostcode')))
                return;
        }

        if (index == 1) {
            if (!checkInputError(jQuery('#MConveyncingFormForm .typeofleasepurchasefree')))
                return;
            if (!checkInputError(jQuery('#MConveyncingFormForm .typeofleasesalefree')))
                return;
        }


        jQuery('#MConveyncingCarousel').carousel('next')
    });




    //-------------------- MCONVEYNCINGFORM FORM END ------------------------------

//--------------------  CONVEYNCING FORM END ------------------------------------

    
    /* eslint-enable */
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/calculator.js